<div class="h-100 w-100 d-flex flex-column flex-grow-1 overflow-auto">

    <div *ngIf="!mandatory" class="position-absolute w-100 d-flex" [class.justify-content-end]="isRTL">
        <button type="button" mat-icon-button aria-label="Close" (click)="closePhoneDialog()"
            class="close-icon d-flex align-items-center justify-content-center" [class.text-white]="isDarkMode">
            <mat-icon>close</mat-icon>
        </button>
    </div>

    <div class="d-flex flex-grow-1 flex-column align-items-center px-3 pt-4 pb-3 px-md-4 pt-md-5 gap-3 w-100"
        [class.zx-ltr]="!isRTL" [class.text-white]="isDarkMode">

        <!-- ================= STEP - PHONE -->
        <ng-container *ngIf="step === 'phone'">
            <h4 class="text-center fw-bold m-0 pt-3 pt-lg-0">
                {{ titleKey | translate }}
            </h4>
            <p class="text-center m-0">
                {{ explainKey | translate }}
            </p>

            <form class="w-100 d-flex flex-column gap-2" (ngSubmit)="onSendCode()">
                <mat-form-field class="w-100">
                    <mat-label>{{ "log-in-dialog-phone-label" | translate }}</mat-label>
                    <mat-icon matIconPrefix style="color: var(--zx-green);">smartphone</mat-icon>
                    <input #phoneInput matInput name="phone" type="tel" inputmode="tel" autocomplete="tel-national"
                        dir="ltr" placeholder="050-1234567" [value]="phone" (input)="onPhoneInput(phoneInput)">
                </mat-form-field>
                <span *ngIf="errorKey" class="text-red text-center zx-text-small">
                    {{ errorKey | translate }}
                </span>
                <button mat-raised-button color="primary" type="submit" class="rounded-pill w-100 text-white"
                    [disabled]="isLoading || !isPhoneValid">
                    <span *ngIf="!isLoading">{{ "log-in-dialog-phone-send-code" | translate }}</span>
                    <mat-spinner *ngIf="isLoading" class="zx-small-icon-size m-auto"></mat-spinner>
                </button>
            </form>

            <span class="text-center zx-text-small">
                {{ "phone-dialog-explain" | translate }}
            </span>
        </ng-container>
        <!-- // ================= STEP - PHONE -->

        <!-- ================= STEP - CODE -->
        <ng-container *ngIf="step === 'code'">
            <h4 class="text-center fw-bold m-0 pt-3 pt-lg-0">
                {{ "log-in-dialog-code-title" | translate }}
            </h4>
            <p class="text-center m-0">
                <span>{{ "log-in-dialog-code-sent-to" | translate }}</span>
                <span class="zx-text-transparent">-</span>
                <b dir="ltr" class="d-inline-block">{{ formattedPhone }}</b>
            </p>
            <p class="text-center m-0 opacity-50">
                {{ "log-in-dialog-code-sent-via" | translate }}
            </p>
            <p class="text-center m-0">
                <span class="zx-text-link" (click)="onChangePhone()">
                    {{ "log-in-dialog-code-change-phone" | translate }}
                </span>
            </p>

            <app-otp-code-input class="w-100" [disabled]="isLoading || isCodeLocked" [hasError]="!!errorKey"
                [isDarkMode]="isDarkMode" (codeComplete)="onVerifyCode($event)"></app-otp-code-input>

            <div class="zx-otp-feedback d-flex flex-column align-items-center justify-content-center text-center">
                <mat-spinner *ngIf="isLoading" class="zx-small-icon-size"></mat-spinner>
                <span *ngIf="!isLoading && errorKey" class="text-red zx-text-small">
                    {{ (isCodeLocked && resendCountdown > 0 ? "otp-error.OTP_TOO_MANY_ATTEMPTS-wait" : errorKey)
                    | translate: { seconds: resendCountdown } }}
                    <span *ngIf="codeAttemptsLeft">
                        ({{ "otp-error.attempts-left" | translate }} {{ codeAttemptsLeft }})
                    </span>
                </span>
                <button *ngIf="!isLoading && isCodeExpired" mat-raised-button color="primary" type="button"
                    class="text-white rounded-pill mt-2" [disabled]="resendCountdown > 0" (click)="onResendCode()">
                    {{ "log-in-dialog-code-send-new" | translate }}
                </button>
            </div>

            <button *ngIf="!isCodeExpired" [style.visibility]="isCodeLocked && resendCountdown > 0 ? 'hidden' : null" mat-button type="button" class="rounded-pill" [disabled]="isLoading || resendCountdown > 0"
                (click)="onResendCode()">
                <span *ngIf="resendCountdown > 0">
                    {{ "log-in-dialog-code-resend-in" | translate }} <span dir="ltr">{{ resendCountdownLabel }}</span>
                </span>
                <span *ngIf="resendCountdown === 0">{{ "log-in-dialog-code-resend" | translate }}</span>
            </button>
        </ng-container>
        <!-- // ================= STEP - CODE -->

        <!-- ================= STEP - DONE -->
        <ng-container *ngIf="step === 'done'">
            <h4 class="text-center fw-bold m-0 pt-3 pt-lg-0 text-green">
                {{ "phone-dialog-updated-success" | translate }}
            </h4>
            <h4 class="fw-bold m-0 text-green" dir="ltr">{{ formatStoredPhone(savedPhone) }}</h4>
        </ng-container>
        <!-- // ================= STEP - DONE -->

        <span *ngIf="mandatory && step !== 'done'" class="zx-text-link zx-text-small pt-2" (click)="onLogout()">
            {{ "phone-dialog-logout" | translate }}
        </span>
    </div>
</div>
